// Ported from cartadigital-pos app/utils/order-type-ui.ts (icons mapped to mdi).
import { OrderType } from '@/enums/OrderEnums';

export interface IOrderTypeUiOption {
  label: string;
  value: OrderType;
  icon: string;
}

export const POS_ORDER_TYPE_UI_OPTIONS: readonly IOrderTypeUiOption[] = [
  { label: 'Mesa', value: OrderType.Seat, icon: 'silverware-fork-knife' },
  { label: 'Llevar', value: OrderType.Away, icon: 'shopping' },
  { label: 'Delivery', value: OrderType.Delivery, icon: 'truck-delivery' },
];

const POS_ORDER_TYPE_LABEL_BY_VALUE = new Map<OrderType, string>(
  POS_ORDER_TYPE_UI_OPTIONS.map((o) => [o.value, o.label])
);

const POS_ORDER_TYPE_ICON_BY_VALUE = new Map<OrderType, string>(
  POS_ORDER_TYPE_UI_OPTIONS.map((o) => [o.value, o.icon])
);

export function getPosOrderTypeLabel(type: OrderType): string {
  return POS_ORDER_TYPE_LABEL_BY_VALUE.get(type) ?? 'Pedido';
}

export function getPosOrderTypeIcon(type: OrderType): string {
  return POS_ORDER_TYPE_ICON_BY_VALUE.get(type) ?? 'receipt';
}
